// extracted by mini-css-extract-plugin
export default {"box":"CartTotal_box__crOQ1","price":"CartTotal_price__hG+YD","taxes":"CartTotal_taxes__ljp0O","total":"CartTotal_total__lEr0t","row":"CartTotal_row__Z1qyX"};